import { Controller } from "stimulus"

export default class extends Controller {
  addRow() {
    this.element.querySelector("#openai-input-mapping-rows").insertAdjacentHTML("beforeend", this.element.querySelector("template").innerHTML.trim())
  }

  filterSurveys(event) {
    const query = event.target.value.trim().toLowerCase()

    this.element.querySelectorAll("[data-survey-filter-item]").forEach((item) => {
      const title = item.dataset.surveyFilterItem.toLowerCase()
      item.classList.toggle("d-none", query.length > 0 && !title.includes(query))
    })
  }

  removeRow(event) {
    const row = event.target.closest(".openai-input-mapping-row")
    if (row) row.remove()
  }
}
